import styled from "styled-components/macro";
import { shimmerOverlay } from "../../../components/Shimmer/Shimmer";

export const StatusSelectorWrapper = styled.div`
  width: 100%;
  margin-top: 60px;

  @media (max-width: 991px) {
    display: none;
  }

  /* ── control (closed state) ── */
  .Dropdown-root {
    position: relative;
  }

  .Dropdown-control {
    display: flex;
    align-items: center;
    background-color: ${(props) => props.theme.colors.faceliftBlue};
    border: none;
    border-radius: 16px;
    padding: 8px 16px;
    cursor: pointer;
    user-select: none;

    &::before {
      content: "Status:";
      color: rgba(255, 255, 255, 0.55);
      font-size: 14px;
    }
  }

  .Dropdown-placeholder {
    color: white;
    font-size: 12px;
    font-weight: 500;
    flex: 1;
    background-color: transparent !important;;
    padding: 12px !important;
    &.is-selected {
      color: white;
    }
  }

  .Dropdown-arrow-wrapper {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .Dropdown-arrow {
    border-color: rgba(255, 255, 255, 0.6) transparent transparent;
    border-style: solid;
    border-width: 8px 6px 0;
    top: -4px;
    right: 5px;
  }

  .is-open .Dropdown-arrow {
    border-color: transparent transparent white;
    border-width: 0 6px 8px;
  }

  .Dropdown-control.is-disabled {
    opacity: 0.5;
    cursor: default;
  }

  /* ── open menu ── */
  .Dropdown-menu {
    border: none;
    border-radius: 16px;
    margin-top: 4px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(24, 31, 56, 0.18);
    z-index: 999;
  }

  .Dropdown-option {
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
    font-weight: 500;
    padding: 10px 16px;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;

    &:hover {
      background-color: rgba(255, 255, 255, 0.08);
      color: white;
    }

    &.is-selected {
      color: white;
      font-weight: 600;
      background-color: rgba(255, 255, 255, 0.12);
    }
  }

  .application-status-selector-dropdown {
    max-height: none !important;
    overflow: hidden !important;
  }
`;

export const StatusSelectorPlaceholder = styled.div`
  position: relative;
  width: 100%;
  height: 63px;
  border-radius: 16px;
  background: ${(props) => props.theme.colors.white};
  overflow: hidden;
  ${shimmerOverlay}

  &::before {
    content: "";
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 68%;
    height: 25px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.3);
    z-index: 1;
  }
`;